"use strict";

import $ from "jquery";

let popover;
let form;
let editButton;
let cancelButton;
let nameField;

const cancelClicked = function (e) {
  e.preventDefault();
  editButton.popover("hide");
};

const formSuccess = function (data) {
  $(".slide-deck-name").text(data.name);
  editButton.popover("hide");
};

const formError = function (error) {
  window.alert(error);
};

const formSubmitted = function (e) {
  e.preventDefault();

  if (nameField.val() == "") {
    editButton.popover("hide");
    return;
  }

  $.ajax(form.attr("action"), {
    method: "POST",
    data: form.serialize(),
    success: formSuccess,
    error: formError
  });
};

const initialiseForm = function () {
  form = popover.find("form");
  nameField = form.find(".slideDeckName");
  cancelButton = popover.find(".cancel");

  form.on("submit", formSubmitted);
  cancelButton.on("click", cancelClicked);

  nameField.focus();
  nameField.select();
};

const loadPopoverContent = function () {
  // (BS5): the tip is appended to <body> (not the trigger's parent) and
  // linked by `aria-describedby`; the body element is `.popover-body` (was BS3
  // `.popover-content`). The form HTML is injected via jQuery `.load()` (not BS5
  // setContent), so it bypasses BS5's sanitizer — the <input> survives.
  const tipId = $(this).attr("aria-describedby");
  popover = tipId ? $("#" + tipId) : $();
  popover.find(".popover-body").load($(this).data("content-url"), null, initialiseForm);
};

$(document).on("turbolinks:load", function () {
  editButton = $("#slideDeckEditBtn");
  if (editButton.length == 0) {
    return; // No edit button on this page
  }

  editButton.popover({
    html: true
  });
  editButton.on("inserted.bs.popover", loadPopoverContent);
  // The BS3 issue-16732 reopen workaround (`$(e.target).data("bs.popover").inState`)
  // was removed: BS5 has no `.data("bs.popover")` (it threw) and fixed that reopen
  // bug natively.
});
